<table class="app-table lieferung-table custom-001">
  <tbody>
    <ng-template ngFor let-vo [ngForOf]="positionen">
      <tr class="position-header" [class.highlighted]="vo.istHighlighted | async">
        <td *ngIf="posNrSichtbar" class="posnr-col">{{ vo.position.PosNr }}.</td>
        <td *ngIf="mengeSichtbar" class="menge-col">{{ vo.position.Menge }}</td>
        <td *ngIf="einheitSichtbar" class="einheit-col">{{ vo.position.Einheit }}</td>
        <td *ngIf="bezeichnungSichtbar" class="beschreibung-col">{{ vo.position.Bezeichnung }}<span *ngIf="vo.position.BhAktion"> ({{ vo.position.BhAktion }})</span></td>
        <td *ngIf="istPlusMinusButtonsAnzeigen(vo.position)" class="plusminus-buttons">
          <ion-button slot="end" color="light" size="default" appClick (clicked)="erhoeheMenge(vo.position)" class="plusminus-button plus-button">+</ion-button>
          <ion-button slot="end" color="light" appClick (clicked)="reduziereMenge(vo.position)" class="plusminus-button minus-button">-</ion-button>
        </td>
      </tr>
    </ng-template>

    <ng-container *ngIf="summeAnzahlSichtbar">
      <tr class="summe">
        <td [attr.colspan]="3">Gesamt: {{ summeAnzahl }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>